import RequestManager from "more/RequestManager";
import { ExtraHelpers } from "../../more/Helpers";

export class localStorage2SharedTeamsState implements Storage { //drop in replacement fuer window.localStorageShim
    private keyBlacklist:Array<string> = [ //NOTE - keys die ja nicht geteilt werden sollten, entweder weil es keinen sinn macht oder evtl. logic briken koennte
        "ego_Translations", "evisioChatId", "ego_NotificationCenter_Settings", "ego_DebugUserroles", "ego_profilePic",
        "ego_userSubstitution", "msTeams_flag_appInstalled"
    ];
    private stateQueue: ExtraHelpers.AsyncOperationQueue; //enqueues async functions, triggeres them in order and then resolves them with value
    private RequestManager: RequestManager = null;
    private teamsTabId: string = "unknown";
    private async teamsStateGet(identifier: string, bypassQueue = false): Promise<string> {
        if (identifier.length > 2048) {
            throw "parameter length exceeded";
            return;
        }
        let getStateFn = async () => {
            return new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_MSTeams_TabAppHelpers_TabState_Get",
                    {
                        identifier: identifier,
                        tabId: this.teamsTabId,
                    },
                    (response: object) => {
                        let respString;
                        if (typeof response != 'string') {
                            respString = JSON.stringify(response);
                        } else {
                            respString = response as string;
                        }
                        resolve(respString)
                    },
                    (errorResponse) => {
                        console.error(errorResponse);
                        reject(JSON.stringify({ success: false, content: "" }));
                    }
                );
            }
            )
        };
        let fnResult: string;
        if (bypassQueue == false) {
            fnResult = await this.stateQueue.enqueue(getStateFn) as any;
        } else {
            fnResult = await getStateFn() as any;
        }
        let fnResultObj: object = JSON.parse(fnResult);
        console.info("get state", identifier, fnResultObj);
        return fnResultObj["content"] as string;
    }
    private async teamsStateSet(identifier: string, content: string, bypassQueue = false): Promise<boolean> {
        if ((identifier.length > 2048) || (content.length > 2147483647)) {
            throw "parameter length exceeded";
            return;
        }
        let setStateFn = async () => {
            return new Promise((resolve, reject) => {
                this.RequestManager.callfunction(
                    "Webtool_MSTeams_TabAppHelpers_TabState_Set",
                    {
                        identifier: identifier,
                        tabId: this.teamsTabId,
                        content: content
                    },
                    (response: object) => {
                        let respString;
                        if (typeof response != 'string') {
                            respString = JSON.stringify(response);
                        } else {
                            respString = response as string;
                        }
                        resolve(respString)
                    },
                    (errorResponse) => {
                        console.error(errorResponse);
                        reject(JSON.stringify({ success: false }));
                    }
                );
            });
        };
        let fnResult: string;
        if (bypassQueue == false) {
            fnResult = await this.stateQueue.enqueue(setStateFn) as any;
        } else {
            fnResult = await setStateFn() as any;
        }
        let fnResultObj = JSON.parse(fnResult);
        console.info("set state", identifier, fnResultObj);
        return fnResultObj["success"] as boolean;
    }

    private actualOriginalStorage: Storage; //z.b. localStorage
    private myData: Record<string, string> = {};
    private myKeysCache: Array<string> = [];
    private flagPassDataToOriginalStorage: boolean = false;
    private isReady = false;
    constructor(originalStorage: Storage, requestMgr: RequestManager, teamTabId: string, stateQueue: ExtraHelpers.AsyncOperationQueue = new ExtraHelpers.AsyncOperationQueue(1), passDataThroughToOriginalStorage: boolean = false) {
        if (typeof stateQueue == 'undefined') {
            stateQueue = new ExtraHelpers.AsyncOperationQueue(1);
        }
        if (stateQueue == null) {
            stateQueue = new ExtraHelpers.AsyncOperationQueue(1);
        }
        this.stateQueue = stateQueue;
        this.flagPassDataToOriginalStorage = passDataThroughToOriginalStorage ?? false;
        this.teamsTabId = teamTabId;
        this.actualOriginalStorage = originalStorage;
        this.RequestManager = requestMgr;
    }

    public async preLoadData(preLoadKeys: Array<string>) {
        if (this.isReady) {
            return;
        }
        if (Array.isArray(preLoadKeys) == false) {
            return;
        }
        if (preLoadKeys.length < 1) {
            return;
        }

        let count = 0;
        let countMax = this.actualOriginalStorage?.length ?? 0;
        if (countMax > 0) {
            while (countMax > count) {
                let k = this.actualOriginalStorage.key(count);
                if (typeof k == 'string') {
                    preLoadKeys.push(k);
                }
                count++;
            }
        }

        //blacklist filter
        preLoadKeys = preLoadKeys.filter((value) =>{
            return this.keyBlacklist.includes(value) == false;
        });

        let promises: Array<Promise<any>> = [];
        for (let key of preLoadKeys) {
            let prom = this.teamsStateGet(key, true);
            prom.then((result: string) => {
                this.myData[key] = result;
            });
            promises.push(prom);
        }
        await Promise.allSettled(promises); //auf alle warten
        this.myKeysCache = Object.keys(this.myData);
        this.length = this.myKeysCache.length;
        this.isReady = true;
        window.addEventListener("beforeunload", this.browserUnloadHandler.bind(this));
    }

    public isBusySyncing() {
        return this.stateQueue.isBusy() ?? false;
    }

    private browserUnloadHandler(ev: BeforeUnloadEvent) {
        if (this.isBusySyncing()) {
            ev.preventDefault();
            ev.returnValue = '';
            return '';
        }
    }

    public dispose() {
        window.removeEventListener('beforeunload', this.browserUnloadHandler);
    }


    //############################################################
    //localStorage drop-in-replacement
    //############################################################
    public length: number = 0;
    public key(index: number): string | null {
        console.info("Storage.key() called with index:", index);
        if (index < 0) {
            console.info("Storage.key() returning null (negative index)");
            return null;
        }
        let keys: Array<string> = Object.keys(this.myData);
        if (index > keys.length) {
            console.info("Storage.key() returning null (index out of bounds)");
            return null;
        }
        const result = keys[index];
        console.info("Storage.key() returning:", result);
        return result;
    }

    public getItem(keyName: string): string | null {
        console.info("Storage.getItem() called with keyName:", keyName);
        this.teamsStateGet(keyName, false).then((val: string) => {
            this.myData[keyName] = val;
            this.myKeysCache = Object.keys(this.myData);
            this.length = this.myKeysCache.length;
            if (this.flagPassDataToOriginalStorage == true) {
                this.actualOriginalStorage.setItem(keyName, val);
            }
            console.info("Storage.getItem() async update completed for key:", keyName, "value:", val);
        });
        const result = this.myData[keyName] ?? "";
        console.info("Storage.getItem() returning (cached):", result);
        return result;
    }

    public setItem(keyName: string, keyValue: string): void {
        console.info("Storage.setItem() called with keyName:", keyName, "keyValue:", keyValue);
        this.teamsStateSet(keyName, keyValue, false);
        this.myData[keyName] = keyValue;
        this.myKeysCache = Object.keys(this.myData);
        this.length = this.myKeysCache.length;
        if (this.flagPassDataToOriginalStorage == true) {
            this.actualOriginalStorage.setItem(keyName, keyValue);
        }
        console.info("Storage.setItem() completed for key:", keyName);
    }

    public removeItem(keyName: string): void {
        console.info("Storage.removeItem() called with keyName:", keyName);
        this.teamsStateSet(keyName, "", false);
        if (this.myKeysCache.includes(keyName)) {
            delete this.myData[keyName];
            this.myKeysCache = Object.keys(this.myData);
            this.length = this.myKeysCache.length;
            if (this.flagPassDataToOriginalStorage == true) {
                this.actualOriginalStorage.removeItem(keyName);
            }
            console.info("Storage.removeItem() completed for key:", keyName);
        } else {
            console.info("Storage.removeItem() key not found:", keyName);
        }
    }

    public clear(): void {
        console.info("Storage.clear() called");
        const keysToRemove = Object.keys(this.myData);
        console.info("Storage.clear() removing keys:", keysToRemove);
        for (let key of keysToRemove) {
            this.removeItem(key);
        }
        console.info("Storage.clear() completed");
    }

}
